
import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import vmodules from '@/components_new/vmodules/vmodules.vue';

@Component({
  name: 'RatesScene',
  components: {
    vmodules
  }
})
export default class RatesScene extends Vue {
  private response_limit_expired_action = '0';
  private is_vacancy_request_sent = false;
  private is_response_request_sent = false;
  private is_tariff_request_sent = false;

  get rates() {
    return this.$store.state.company_new.rates;
  }

  get paid_to() {
    if (!this.rates || (!this.rates.paid_to && this.rates.paid_to !== null)) {
      return '';
    }

    if (this.rates.paid_to === null) {
      return this.$tr('rates.noLimit');
    }

    return moment(this.rates.paid_to).lang(this.currentLocale).format('DD MMMM YYYY');
  }

  get is_paid_to_unlimited() {
    if (!this.rates) {
      return false;
    }

    return this.rates.paid_to === null;
  }

  get isRatesExpired() {
    return this.$store.getters['company_new/isRatesExpired'];
  }

  get isRatesStarted() {
    return this.$store.getters['company_new/isRatesStarted'];
  }

  get company() {
    return this.$store.getters['company/one'];
  }

  get company_id() {
    if (!this.company) {
      return null;
    }

    return this.company.id;
  }

  get response_limit() {
    if (!this.rates) {
      return undefined;
    }

    return this.rates.response_limit;
  }

  // get last_purchase_responses_paid_count() {
  //   if (!this.rates) {
  //     return 0;
  //   }

  //   if (
  //     this.rates.last_purchase_responses_paid_count !== null &&
  //     this.rates.last_purchase_responses_paid_count !== undefined
  //   ) {
  //     return this.rates.last_purchase_responses_paid_count;
  //   }

  //   return this.response_limit;
  // }

  get response_balance() {
    return this.$store.getters['company_new/response_balance'];
  }

  get vacancy_limit() {
    if (!this.rates) {
      return undefined;
    }

    return this.rates.vacancy_limit;
  }

  get vacancy_balance() {
    if (!this.rates) {
      return null;
    }

    return this.rates.vacancy_balance;
  }

  get currentLocale() {
    return this.$store.state.locale.value;
  }

  get extend_tooltip_options() {
    if (!this.isRatesExpired) {
      return {};
    }

    return {
      content: this.$tr('rates.extendTariff'),
      placement: 'top-center',
      classes: 'tight'
    };
  }

  get modules() {
    return this.$store.getters['companyModules/getModules'];
  }

  get availableModules() {
    const availableModules = this.modules.reduce((acc, item) => {
      if (!item.is_enabled) {
        acc.push(item);
      }
      return acc;
    }, []);
    return availableModules;
  }

  get enabledModules() {
    const enabledModules = this.modules.reduce((acc, item) => {
      if (item.is_enabled && item.is_active_by_default !== null) {
        acc.push(item);
      }
      return acc;
    }, []);
    return enabledModules;
  }

  @Watch('rates', {
    immediate: true
  })
  ratesChanged(val) {
    if (!val) {
      return;
    }
    this.response_limit_expired_action = val.save_no_paid_responses ? '1' : '0';
  }

  public fetch_rates() {
    this.$store.dispatch('company_new/get_rates');
  }

  public fetch_company() {
    this.$store.dispatch('company/fetch');
  }

  public save_responses() {
    this.$store.dispatch('company_new/update_rates', {
      company_id: this.company_id,
      save_no_paid_responses: this.response_limit_expired_action
    });
  }

  public extend_rates(type = 'tariff') {
    this.$store
      .dispatch('company_new/extend_rates', {
        company_id: this.company_id,
        type
      })
      .then(() => {
        this.$noty.success(this.$tr('rates.successRequest'));

        switch (type) {
          case 'tariff':
            this.is_tariff_request_sent = true;
            break;
          case 'vacancy':
            this.is_vacancy_request_sent = true;
            break;
          case 'response':
            this.is_response_request_sent = true;
            break;
        }
      })
      .catch(e => {
        this.$noty.error(e.response.data.meta.error.message + '.');
      });
  }

  public fetchModules() {
    this.$store.dispatch('companyModules/fetch');
  }

  public handleSwitch(params) {
    this.$store
      .dispatch('companyModules/updateModule', {
        value: params.value,
        id: params.id,
        key: 'is_active_by_default',
        body: {
          id: params.id,
          is_active_by_default: params.value
        }
      })
      .then(this.$noty.success(this.$tr('vacancy.basic.form.modules.informers.save_success')))
      .catch(() => this.$noty.error(this.$tr('vacancy.basic.form.modules.informers.save_error')));
  }

  public requestModulePayment(id) {
    this.$store
      .dispatch('companyModules/requestModulePayment', { id })
      .then(() => {
        this.$noty.success(this.$tr('rates.successRequest'));
      })
      .catch(e => {
        this.$noty.error(e.response.data.meta.error.message + '.');
      });
  }

  beforeMount() {
    this.fetch_rates();
    this.fetch_company();
    this.fetchModules();
  }
}
